module.exports = __webpack_public_path__ + "static/media/cases_logos_eventos_01.9a375249.jpg";